/**
 * @file Discover Album Folder Start view.
 */

import React from 'react';

import DiscoverAlbumFolderStartContainer from '../../containers/discover/DiscoverAlbumFolderStartContainer';

const DiscoverAlbumFolderStartView = () => (
  <DiscoverAlbumFolderStartContainer />
);

export default DiscoverAlbumFolderStartView;
